import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "converted-bid"
}
const _hoisted_2 = { class: "converted-amount" }

import { computed } from "vue";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { format_currency } from "@/utils/currencies";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CurrencyConverted',
  setup(__props) {

  const auctionStore = useAuctionStore();
  const currentBid = computed(() => auctionStore.activeLot.current_bid);
  const currency = computed(() => auctionStore.currency);
  const isCurrencyBase = computed(() => auctionStore.isCurrencyBase);
  const currencies = computed(() => auctionStore.currencies);
  const selectedCurrency = computed(() => currencies.value.find(item => item.abbr === currency.value));

  const formatCurrency = (amount: number) => {
    return format_currency(amount, "");
  }

return (_ctx: any,_cache: any) => {
  return (!isCurrencyBase.value && currentBid.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(selectedCurrency.value ? formatCurrency(currentBid.value * selectedCurrency.value.rate) : '~') + " " + _toDisplayString(currency.value), 1)
      ]))
    : _createCommentVNode("", true)
}
}

})